<template>
    <div>
        <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
            {{ successMessage }}
        </div>
        <b-card>
            <b-row>
                <div class="col-12 mt-16">
                    <b-form @submit.prevent="addUser" v-if="show">
                        <div v-if="type === 'user'">
                        <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                Personal Information
                            </h4>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="First Name:" label-for="first_name">
                                    <b-form-input id="first_name" type="text" placeholder="Enter first name":state="firstNameState" autocomplete="off"
                                        v-model="first_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Middle Name:" label-for="second_name">
                                    <b-form-input id="second_name" type="text" placeholder="Enter  second name" :state="secondNameState" autocomplete="off"
                                        v-model="second_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Last Name:" label-for="last_name">
                                    <b-form-input id="last_name" type="text" placeholder="Enter  last name":state="lastNameState" autocomplete="off"
                                        v-model="last_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Second Surname:" label-for="second_last_name">
                                    <b-form-input id="second_last_name" type="text" placeholder="Enter second surname":state="secondLastNameState" autocomplete="off"
                                        v-model="second_last_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Date of Birth:" label-for="birthdate">
                                    <b-form-input id="birthdate" type="date" placeholder="Enter date of  birth":state="birthdateState" autocomplete="off"
                                        v-model="birthdate" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Profession:" label-for="profession">
                                    <b-form-input id="profession" type="text" placeholder="Enter profession":state="professionState" autocomplete="off"
                                        v-model="profession" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Voter Credendial Number:" label-for="voter_credential_number">
                                    <b-form-input id="voter_credential_number" type="text" placeholder="Enter voter credential number":state="voterCredentialState" autocomplete="off"
                                        v-model="voter_credential_number" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Zip Code:" label-for="postcode">
                                    <b-form-input id="postcode" type="text" placeholder="Enter Zip code":state="postcodeState"
                                        v-model="postcode" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Address:" label-for="street_address">
                                    <b-form-input id="street_address" type="text" placeholder="Enter street address":state="addressState"
                                        v-model="street_address" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Type:" label-for="type">
                                    <b-form-input id="type" type="text" placeholder="Enter type"
                                        v-model="type" required>
                                    </b-form-input>
                                </b-form-group>
                            </div> -->

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Email Address:" label-for="email">
                                    <b-form-input id="email" type="email" placeholder="Enter email address":state="emailState"
                                        v-model="email">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Mobile:" label-for="phone_number">
                                    <b-form-input id="phone_number" type="number" placeholder="Enter mobile number":state="phoneState"
                                        v-model="formattedPhoneNumber"></b-form-input>
                                </b-form-group>
                            </div>
                           
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="City:" label-for="city">
                                    <b-form-input id="city" placeholder="Enter city":state="cityState" v-model="city">
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Country:" label-for="country">
                                    <b-form-input id="country" placeholder="Enter country":state="countryState" v-model="country"></b-form-input>
                                </b-form-group>
                            </div>
                        
                            <div class="col-md-4 col-12">
                            <b-form-group id="input-group-2" label="Status:" label-for="status">
                                <b-form-select
                                id="status"
                                v-model="status"
                                :options="statusOptions"
                                required
                                ></b-form-select>
                            </b-form-group>
                            </div>
   
                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Profile Picture:" label-for="image">
                                    <div style="margin-left: 3px; margin-bottom: 15px">
                                        <div v-if="editedUser.image">
                                        <img :src="'https://wossdb.wossautoid.com/' + image
                                            " alt="Picture" style="max-width: 100px; max-height: 100px" />
                                        </div>
                                        <div v-else>
                                            <span>No image available</span>
                                        </div>
                                        <input type="file" accept="image/*" id="image"
                                            @change="onProfilePictureChange" />
                                    </div>
                                </b-form-group>
                            </div> -->
                                    <!-- Document  code  here  -->
                        
                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Document:" label-for="documents">
                                    <div style="margin-left: 3px; margin-bottom: 15px">
                                     <div v-if="editedUser.documents">
                                        <a :href="'https://wossdb.wossautoid.com/' + editedUser.documents" target="_blank">
                                        <i class="fas fa-file-pdf" style="margin-right: 5px;"></i> PDF
                                        </a>
                                    </div>
                                    <div v-else>
                                    <span>No document available</span>
                                    </div>
                                    <input type="file" id="documents" @change="onProfilePictureChangeDocument" />
                                    </div>
                                </b-form-group>
                            </div> -->


                            <!-- Profile Picture -->
                            <div class="col-md-4 col-12">
                                <b-form-group label="Profile Picture:" label-for="image" label-class="font-weight-bold" description="Recommended size: 300x300px (JPG/PNG)">
                                    <!-- Current Image -->
                                    <div v-if="editedUser.image && !newImagePreview" class="mb-2">
                                    <small class="text-muted">Current Picture:</small><br />
                                    <img
                                        :src="'https://wossdb.wossautoid.com/' + editedUser.image"
                                        alt="Current Picture"
                                        class="img-thumbnail"
                                        style="max-height: 120px;"
                                    />
                                    </div>

                                    <!-- Upload Area -->
                                    <div
                                    class="border rounded p-3 text-center"
                                    style="cursor: pointer; background: #f9f9f9;"
                                    @drop.prevent="onImageDrop"
                                    @dragover.prevent
                                    @click="$refs.imageInput.click()"
                                    >
                                    <div v-if="!newImagePreview">
                                        <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                                        <p class="mb-0">Drag & Drop or Click to Upload</p>
                                    </div>
                                    <div v-else>
                                        <img
                                        :src="newImagePreview"
                                        alt="Preview"
                                        class="img-thumbnail"
                                        style="max-height: 120px;"
                                        />
                                    </div>
                                    <input
                                        ref="imageInput"
                                        type="file"
                                        accept="image/png, image/jpeg"
                                        class="d-none"
                                        @change="onProfilePictureChange"
                                    />
                                    </div>
                                    <small class="text-muted">Leave empty to keep current image</small>
                                    <b-form-invalid-feedback v-if="profileError" class="d-block text-danger">
                                    {{ profileError }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                            <!-- Document -->
                            <!-- <div class="col-md-4 col-12">
                                <b-form-group label="Document:" label-for="documents" label-class="font-weight-bold" description="Upload PDF/DOCX (Max 10MB)">
                                     <div v-if="editedUser.documents && !newDocumentName" class="mb-2">
                                    <small class="text-muted">Current Document:</small><br />
                                    <a :href="'https://wossdb.wossautoid.com/' + editedUser.documents" target="_blank">
                                        <i class="fas fa-file-pdf" style="margin-right: 5px;"></i> View Document
                                    </a>
                                    </div>

                                     <div
                                    class="border rounded p-3 text-center"
                                    style="cursor: pointer; background: #f9f9f9;"
                                    @drop.prevent="onDocumentDrop"
                                    @dragover.prevent
                                    @click="$refs.docInput.click()"
                                    >
                                    <div v-if="!newDocumentName">
                                        <i class="fas fa-file-upload fa-2x text-muted"></i>
                                        <p class="mb-0">Drag & Drop or Click to Upload</p>
                                    </div>
                                    <div v-else>
                                        <i class="fas fa-file-alt fa-2x text-primary"></i>
                                        <p class="mb-0">{{ newDocumentName }}</p>
                                    </div>
                                    <input
                                        ref="docInput"
                                        type="file"
                                        accept=".pdf,.doc,.docx"
                                        class="d-none"
                                        @change="onProfilePictureChangeDocument"
                                    />
                                    </div>
                                    <small class="text-muted">Leave empty to keep current document</small>
                                    <b-form-invalid-feedback v-if="documentError" class="d-block text-danger">
                                    {{ documentError }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </div> -->
                            <div class="col-md-4 col-12">
                                <b-form-group
                                    label="Documents:"
                                    label-class="font-weight-bold"
                                    description="Upload PDF/DOCX (Max 10MB)"
                                >
                                    <div
                                    v-if="editedUser.profile_document && editedUser.profile_document.length"
                                    >
                                    <div
                                        v-for="(doc, index) in editedUser.profile_document"
                                        :key="doc.id"
                                        class="mb-3"
                                    >
                                        <!-- Current Document -->
                                        <div v-if="doc.documents && !doc.newDocumentName" class="mb-2">
                                        <small class="text-muted">Current Document:</small><br />
                                        <a :href="baseUrl + doc.documents" target="_blank">
                                            <i class="fas fa-file-pdf" style="margin-right: 5px;"></i> View Document
                                        </a>
                                        </div>

                                        <!-- SAME Upload Box UI -->
                                        <div
                                        class="border rounded p-3 text-center"
                                        style="cursor:pointer; background:#f9f9f9"
                                        @drop.prevent="onDocumentDrop($event, doc)"
                                        @dragover.prevent
                                        
                                        @click="triggerDocInput(doc.id)"
                                        >
                                        <div v-if="!doc.newDocumentName">
                                            <i class="fas fa-file-upload fa-2x text-muted"></i>
                                            <p class="mb-0">Drag & Drop or Click to Upload</p>
                                        </div>

                                        <div v-else>
                                            <i class="fas fa-file-alt fa-2x text-primary"></i>
                                            <p class="mb-0">{{ doc.newDocumentName }}</p>
                                        </div>

                                        <input
                                            :ref="'docInput'+doc.id"
                                            type="file"
                                            accept=".pdf,.doc,.docx,image/jpeg,image/png"
                                            class="d-none"
                                            @change="onProfileDocumentChange($event, doc)"
                                        />
                                        </div>

                                        <!-- Document Type -->
                                        <b-form-select
                                        v-model="doc.documents_type"
                                        :options="documentTypes"
                                        size="sm"
                                        class="mt-2"
                                        />

                                        <!-- Expiry -->
                                        <b-form-input
                                        type="date"
                                        v-model="doc.expiration_date"
                                        size="sm"
                                        class="mt-2"
                                        />

                                        <!-- Actions -->
                                        <div class="d-flex mt-2">
                                        <b-button
                                            size="sm"
                                            variant="primary"
                                            class="mr-2"
                                            @click="updateDocument(doc)"
                                        >
                                            Update
                                        </b-button>

                                        <b-button
                                            size="sm"
                                            variant="danger"
                                            @click="deleteDocument(doc.id, index)"
                                        >
                                            Delete
                                        </b-button>
                                        </div>

                                        <hr />
                                    </div>
                                    </div>

                                    <div v-else>
                                    <span>No document available</span>
                                    </div>
                                    <!-- Add New Document Section -->
                                    <div class="mt-4">
                                    <!-- Upload box -->
                                    <div
                                        class="border rounded p-3 text-center"
                                        style="cursor:pointer; background:#f9f9f9"
                                        @drop.prevent="onNewDocumentDrop"
                                        @dragover.prevent
                                        @click="$refs.newDocInput.click()"
                                    >
                                        <div v-if="!newDocument.name">
                                            <i class="fas fa-file-upload fa-2x text-muted"></i>
                                            <p class="mb-0">Drag & Drop or Click to Upload</p>
                                        </div>

                                        <div v-else>
                                            <i class="fas fa-file-alt fa-2x text-primary"></i>
                                            <p class="mb-0">{{ newDocument.name }}</p>
                                        </div>

                                        <input
                                            ref="newDocInput"
                                            type="file"
                                            class="d-none"
                                            accept=".pdf,.doc,.docx,image/jpeg,image/png"
                                            @change="onNewDocumentChange"
                                        />
                                    </div>
                                        <!-- Document Type -->
                                        <b-form-select
                                            v-model="newDocument.documents_type"
                                            :options="documentTypes"
                                            class="mt-2"
                                            size="sm"
                                        />

                                        <!-- Expiry -->
                                        <b-form-input
                                            type="date"
                                            v-model="newDocument.expiration_date"
                                            class="mt-2"
                                            size="sm"
                                        />

                                        <!-- Upload -->
                                        <b-button
                                            variant="success"
                                            size="sm"
                                            class="mt-3"
                                            :disabled="isUploading"
                                            @click="addNewDocument"
                                        >
                                            Add New Document
                                        </b-button>

                                        <small v-if="documentError" class="text-danger d-block mt-2">
                                            {{ documentError }}
                                        </small>
                                    </div>
                                        <b-modal
                                            v-model="showDeleteModal"
                                            title="Confirm Deletion"
                                            ok-title="Delete"
                                            cancel-title="Cancel"
                                            @ok="confirmDeleteDocument"
                                            @cancel="cancelDeleteDocument"
                                        >
                                            <p>Are you sure you want to delete this document? This action cannot be undone.</p>
                                        </b-modal>
                                </b-form-group>
                            </div>
                        </div>
                        </div>


                        <div v-if="type === 'company'">   
                            <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                Personal Information
                            </h4>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="First Name:" label-for="first_name">
                                    <b-form-input id="first_name" type="text" placeholder="Enter first name":state="firstNameState" autocomplete="off"
                                        v-model="first_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Middle Name:" label-for="second_name">
                                    <b-form-input id="second_name" type="text" placeholder="Enter  second name":state="secondNameState" autocomplete="off"
                                        v-model="second_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Last Name:" label-for="last_name">
                                    <b-form-input id="last_name" type="text" placeholder="Enter  last name":state="lastNameState" autocomplete="off"
                                        v-model="last_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Second Surname:" label-for="second_last_name">
                                    <b-form-input id="second_last_name" type="text" placeholder="Enter second surname":state="secondLastNameState" autocomplete="off"
                                        v-model="second_last_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Date of Birth:" label-for="birthdate">
                                    <b-form-input id="birthdate" type="date" placeholder="Enter date of  birth":state="birthdateState" autocomplete="off"
                                        v-model="birthdate" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Profession:" label-for="profession">
                                    <b-form-input id="profession" type="text" placeholder="Enter profession" :state="professionState" autocomplete="off"
                                        v-model="profession" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Voter Credendial Number:" label-for="voter_credential_number">
                                    <b-form-input id="voter_credential_number" type="text" placeholder="Enter voter credential number":state="voterCredentialState" autocomplete="off"
                                        v-model="voter_credential_number" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Zip Code:" label-for="postcode">
                                    <b-form-input id="postcode" type="text" placeholder="Enter Zip code":state="postcodeState"
                                        v-model="postcode" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Address:" label-for="street_address">
                                    <b-form-input id="street_address" type="text" placeholder="Enter street address":state="addressState"
                                        v-model="street_address" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Type:" label-for="type">
                                    <b-form-input id="type" type="text" placeholder="Enter type"
                                        v-model="type" required>
                                    </b-form-input>
                                </b-form-group>
                            </div> -->

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Email Address:" label-for="email">
                                    <b-form-input id="email" type="email" placeholder="Enter email address":state="emailState"
                                        v-model="email">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Mobile:" label-for="phone_number">
                                    <b-form-input id="phone_number" type="number" placeholder="Enter mobile number":state="phoneState"
                                        v-model="phone_number" ></b-form-input>
                                </b-form-group>
                            </div>
                           
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="City:" label-for="city">
                                    <b-form-input id="city" placeholder="Enter city":state="cityState" v-model="city">
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Country:" label-for="country">
                                    <b-form-input id="country" placeholder="Enter country":state="countryState" v-model="country"></b-form-input>
                                </b-form-group>
                            </div>
                        
                            <div class="col-md-4 col-12">
                            <b-form-group id="input-group-2" label="Status:" label-for="status">
                                <b-form-select
                                id="status"
                                v-model="status"
                                :options="statusOptions"
                                required
                                ></b-form-select>
                            </b-form-group>
                            </div>
  
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Profile Picture:" label-for="image">
                                    <div style="margin-left: 3px; margin-bottom: 15px">
                                        <div v-if="editedUser.image">
                                        <img :src="'https://wossdb.wossautoid.com/' + image
                                            " alt="Picture" style="max-width: 100px; max-height: 100px" />
                                        </div>
                                        <div v-else>
                                            <span>No image available</span>
                                        </div>
                                        <input type="file" accept="image/*" id="image"
                                            @change="onProfilePictureChange" />
                                    </div>
                                </b-form-group>
                            </div>
                                    <!-- Document  code  here  -->
                        
                    <!-- <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Document:" label-for="documents">
                    <div style="margin-left: 3px; margin-bottom: 15px">
                    <div v-if="editedUser.documents">
                        <a :href="'https://wossdb.wossautoid.com/' + editedUser.documents" target="_blank">
                        <i class="fas fa-file-pdf" style="margin-right: 5px;"></i> PDF
                        </a>
                    </div>
                     <div v-else>
                    <span>No document available</span>
                    </div>
                    <input type="file" accept=".pdf,.doc,.docx,image/jpeg,image/png" id="documents" @change="onProfilePictureChangeDocument" />
                    </div>
                </b-form-group>
                </div> -->
                            <div class="col-md-4 col-12">
                                <b-form-group
                                    label="Documents:"
                                    label-class="font-weight-bold"
                                    description="Upload PDF/DOCX (Max 10MB)"
                                >
                                    <div
                                    v-if="editedUser.profile_document && editedUser.profile_document.length"
                                    >
                                    <div
                                        v-for="(doc, index) in editedUser.profile_document"
                                        :key="doc.id"
                                        class="mb-3"
                                    >
                                        <!-- Current Document -->
                                        <div v-if="doc.documents && !doc.newDocumentName" class="mb-2">
                                        <small class="text-muted">Current Document:</small><br />
                                        <a :href="baseUrl + doc.documents" target="_blank">
                                            <i class="fas fa-file-pdf" style="margin-right: 5px;"></i> View Document
                                        </a>
                                        </div>

                                        <!-- SAME Upload Box UI -->
                                        <div
                                        class="border rounded p-3 text-center"
                                        style="cursor:pointer; background:#f9f9f9"
                                        @drop.prevent="onDocumentDrop($event, doc)"
                                        @dragover.prevent
                                        
                                        @click="triggerDocInput(doc.id)"
                                        >
                                        <div v-if="!doc.newDocumentName">
                                            <i class="fas fa-file-upload fa-2x text-muted"></i>
                                            <p class="mb-0">Drag & Drop or Click to Upload</p>
                                        </div>

                                        <div v-else>
                                            <i class="fas fa-file-alt fa-2x text-primary"></i>
                                            <p class="mb-0">{{ doc.newDocumentName }}</p>
                                        </div>

                                        <input
                                            :ref="'docInput'+doc.id"
                                            type="file"
                                            accept=".pdf,.doc,.docx,image/jpeg,image/png"
                                            class="d-none"
                                            @change="onProfileDocumentChange($event, doc)"
                                        />
                                        </div>

                                        <!-- Document Type -->
                                        <b-form-select
                                        v-model="doc.documents_type"
                                        :options="documentTypes"
                                        size="sm"
                                        class="mt-2"
                                        />

                                        <!-- Expiry -->
                                        <b-form-input
                                        type="date"
                                        v-model="doc.expiration_date"
                                        size="sm"
                                        class="mt-2"
                                        />

                                        <!-- Actions -->
                                        <div class="d-flex mt-2">
                                        <b-button
                                            size="sm"
                                            variant="primary"
                                            class="mr-2"
                                            @click="updateDocument(doc)"
                                        >
                                            Update
                                        </b-button>

                                        <b-button
                                            size="sm"
                                            variant="danger"
                                            @click="deleteDocument(doc.id, index)"
                                        >
                                            Delete
                                        </b-button>
                                        </div>

                                        <hr />
                                    </div>
                                    </div>

                                    <div v-else>
                                    <span>No document available</span>
                                    </div>
                                    <!-- Add New Document Section -->
                                    <div class="mt-4">
                                    <!-- Upload box -->
                                    <div
                                        class="border rounded p-3 text-center"
                                        style="cursor:pointer; background:#f9f9f9"
                                        @drop.prevent="onNewDocumentDrop"
                                        @dragover.prevent
                                        @click="$refs.newDocInput.click()"
                                    >
                                        <div v-if="!newDocument.name">
                                            <i class="fas fa-file-upload fa-2x text-muted"></i>
                                            <p class="mb-0">Drag & Drop or Click to Upload</p>
                                        </div>

                                        <div v-else>
                                            <i class="fas fa-file-alt fa-2x text-primary"></i>
                                            <p class="mb-0">{{ newDocument.name }}</p>
                                        </div>

                                        <input
                                            ref="newDocInput"
                                            type="file"
                                            class="d-none"
                                            accept=".pdf,.doc,.docx,image/jpeg,image/png"
                                            @change="onNewDocumentChange"
                                        />
                                    </div>
                                        <!-- Document Type -->
                                        <b-form-select
                                            v-model="newDocument.documents_type"
                                            :options="documentTypes"
                                            class="mt-2"
                                            size="sm"
                                        />

                                        <!-- Expiry -->
                                        <b-form-input
                                            type="date"
                                            v-model="newDocument.expiration_date"
                                            class="mt-2"
                                            size="sm"
                                        />

                                        <!-- Upload -->
                                        <b-button
                                            variant="success"
                                            size="sm"
                                            class="mt-3"
                                            :disabled="isUploading"
                                            @click="addNewDocument"
                                        >
                                            Add New Document
                                        </b-button>

                                        <small v-if="documentError" class="text-danger d-block mt-2">
                                            {{ documentError }}
                                        </small>
                                    </div>
                                        <b-modal
                                            v-model="showDeleteModal"
                                            title="Confirm Deletion"
                                            ok-title="Delete"
                                            cancel-title="Cancel"
                                            @ok="confirmDeleteDocument"
                                            @cancel="cancelDeleteDocument"
                                        >
                                            <p>Are you sure you want to delete this document? This action cannot be undone.</p>
                                        </b-modal>
                                </b-form-group>
                            </div>
                        </div>  
                                
                        <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                Company Information
                            </h4>
                        </div>
                        <div class="row">
                        
                        <div class="col-md-4 col-12">
                            <b-form-group id="input-group-1" label="Company Name:" label-for="company_name">
                                <b-form-input id="company_name" type="text" placeholder="Enter company name":state="companyNameState" autocomplete="off"
                                    v-model="company_name" required>
                                </b-form-input>
                            </b-form-group>
                        </div>
                         
                      
                        <div class="col-md-4 col-12">
                            <b-form-group id="input-group-1" label="Registro Federal Contribuyente:" label-for="rfc">
                                <b-form-input id="rfc" type="text" placeholder="Enter  rfc":state="rfcState" autocomplete="off"
                                    v-model="rfc" required>
                                </b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col-md-4 col-12">
                            <b-form-group id="input-group-1" label="Trade Name:" label-for="trade_name">
                                <b-form-input id="trade_name" type="text" placeholder="Enter trade name":state="tradeNameState" autocomplete="off"
                                    v-model="trade_name" required>
                                </b-form-input>
                            </b-form-group>
                        </div>

                        <div class="col-md-4 col-12">
                            <b-form-group id="input-group-1" label="Office Phone Number:" label-for="office_phone">
                                <b-form-input id="office_phone" type="text" placeholder="Enter office phone nnumber":state="officePhoneState" autocomplete="off"
                                    v-model="office_phone" required>
                                </b-form-input>
                            </b-form-group>
                        </div>
                        </div>
    
                    </div>

                        <!-- Bank Information End -->
                        <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
                            <span v-if="!isLoading">Submit</span>
                            <b-spinner v-else class="mb-8 mr-8" variant="primary" small></b-spinner>
                        </b-button>
                    </b-form>
                </div>
                <div v-if="codeActive" class="col-12 mt-24 hljs-container" :class="{ active: codeActiveClass }">
                    <pre v-highlightjs>
            <code class="hljs html">
              {{ codeText }}
            </code>
          </pre>
                </div>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BSpinner,
    BModal,
} from "bootstrap-vue";
// import axios from "axios";
import axios from "../../../axios";
import { BToast } from "bootstrap-vue";
import code from "@/view/components/data-entry/form/code";

export default {
    data() {
        return {
            newDocument: {
            file: null,
            name: null,
            documents_type: '',
            expiration_date: ''
        },
        documentTypes: [
            { value: 'ID', text: 'ID' },
            { value: 'Passport', text: 'Passport' },
            { value: 'Driver\'s license', text: 'Driver\'s license' }
        ],
        documentError: '',
        isUploading: false,
            show: true,
            successMessage: "",
            codeText: code.introduction,
            codeActive: false,
            codeActiveClass: false,
            selectedOption: "",
            inputField1: "",
            inputField2: "",
            inputField3: "",
            showModal: false,
            isLoading: false,

            first_name: "",
            second_name:"",
            last_name:"",
            second_last_name:"",
            birthdate:"",
            profession:"",
            voter_credential_number:"",
            postcode:"",
            street_address:"",
            type:"",
            email: "",
            status: "",
            phone_number: "",
            city:"",
            country:"",
            status:"",
            company_name: "",
            rfc:"",
            trade_name:"",
            office_phone:"",
            newImage: null,
            newImagePreview: null,
            profileError: "",

            newDocumentName: null,
            documentError: "",
            showDeleteModal: false,  // Add this for modal visibility
            documentToDelete: null, 
                  
      statusOptions: [
        { value: null, text: 'Select status of vehicle' },
        { value: 'Pending', text: 'Pending' },
        { value: 'Approved', text: 'Approved' },
        { value: 'Rejected', text: 'Rejected' }
      ],
            image: "",
            documents: null, 
            editedUser: {},
            baseUrl: 'https://wossdb.wossautoid.com/',
            documentTypes: ['ID', 'Passport', 'Driver\'s license']

        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BForm,
        BFormGroup,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormSelect,
        BFormInput,
        BToast, // Add this line
        BSpinner,
        BModal, 
    },

    created() {
    // Load the clients data when the component is created
    const userId = this.$route.params.id;
        axios
            .get(`UserGet/${userId}`)
            .then((response) => {

                this.editedUser = response.data.data;
                this.first_name = this.editedUser.first_name;
                this.second_name = this.editedUser.second_name;
                this.last_name = this.editedUser.last_name;
                this.second_last_name = this.editedUser.second_last_name;
                this.birthdate = this.editedUser.birthdate;
                this.profession = this.editedUser.profession;
                this.voter_credential_number = this.editedUser.voter_credential_number;
                this.postcode = this.editedUser.postcode;
                this.street_address = this.editedUser.street_address;
                this.type = this.editedUser.type;
                this.phone_number = this.editedUser.phone_number ? this.editedUser.phone_number.replace(/^\+/,'') : '';
                this.city = this.editedUser.city|| '';
                this.email = this.editedUser.email;
                this.country = this.editedUser.country ||'';
                this.status = this.editedUser.status;
                this.image = this.editedUser.image ||'';
                this.documents = this.editedUser.documents ||'';
                this.company_name = this.editedUser.company_name;
                this.rfc = this.editedUser.rfc ||'';
                this.trade_name = this.editedUser.trade_name ||'';
                this.office_phone = this.editedUser.office_phone ||'';
                if (!this.editedUser.profile_document) {
                this.editedUser.profile_document = [];
            }
                this.editedUser.profile_document = this.editedUser.profile_document.map(doc => ({
                ...doc,
                newFile: null,
                newDocumentName: null
            }));
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
            });
    },
    computed:{
     formattedPhoneNumber:{
        get(){
            return this.phone_number;
        },
        set(value){
         this.phone_number =value.replace(/^\+/,'');
        }
     },
        firstNameState() { return this.validateField(this.first_name); },
        secondNameState() { return this.validateField(this.second_name); },
        lastNameState() { return this.validateField(this.last_name); },
        secondLastNameState() { return this.validateField(this.second_last_name); },
        birthdateState() { return this.validateField(this.birthdate); },
        professionState() { return this.validateField(this.profession); },
        voterCredentialState() { return this.validateField(this.voter_credential_number); },
        postcodeState() { return this.validateField(this.postcode); },
        addressState() { return this.validateField(this.street_address); },
        emailState() { return this.validateField(this.email, "email"); },
        phoneState() { return this.validateField(this.phone_number, "number"); },
        cityState() { return this.validateField(this.city); },
        countryState() { return this.validateField(this.country); },
        companyNameState() { return this.validateField(this.company_name); },
        rfcState() { return this.validateField(this.rfc); },
        tradeNameState() { return this.validateField(this.trade_name); },
        officePhoneState() { return this.validateField(this.office_phone, "number"); },
    },
    methods: {
        validateField(value, type = "text") {
            if (value === null || value === undefined|| value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/;
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },    
        showMsgBoxOne() {
            debugger;
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
            // debugger
        },
      
        addUser() {
            this.isLoading = true;
            // Create a FormData object to handle the image file

            const formData = new FormData();
            formData.append("first_name", this.first_name);
            formData.append("second_name", this.second_name);
            formData.append("last_name", this.last_name);
            formData.append("second_last_name", this.second_last_name);
            formData.append("birthdate", this.birthdate);
            formData.append("profession", this.profession);
            formData.append("voter_credential_number", this.voter_credential_number);
            formData.append("postcode", this.postcode);
            formData.append("type", this.type);
            formData.append("street_address", this.street_address);
            formData.append("email", this.email);
            formData.append("phone_number", this.phone_number);
            formData.append("city", this.city);
            formData.append("country", this.country);
            formData.append("status", this.status);
            formData.append("image", this.image);
            formData.append("company_name", this.company_name);
            formData.append("rfc", this.rfc);
            formData.append("trade_name", this.trade_name);
            formData.append("last_name", this.last_name);
            formData.append("office_phone", this.office_phone);
             
            if (this.documents) {
                formData.append("documents", this.documents); // Ensure documents are uploaded correctly
            }
            if (this.newImage) {
                formData.append("image", this.newImage);
            }
            if (this.newDocument) {
                formData.append("documents", this.newDocument);
            }
            axios
                .post(`updateReguest/${this.editedUser.id}`, formData)
                .then(() => {
                    this.$bvToast.toast("User Update successfully!", {
                        title: "Success",
                        variant: "primary",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                    });
                    this.isLoading = false;
                    this.$router.push({ name: 'ListUser' });
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                    this.isLoading = false;
                });
        },

        onProfilePictureChange(event) {
            const file = event.target.files[0];
            if (file) {
                // Set the selected file to the data property
                this.image = file;
            }
        },

        onProfilePictureChangeDocument(event) {
            const file = event.target.files[0];
            if (file) {
                this.documents = file;
            }
            },

        codeClick() {
            this.codeActive = !this.codeActive;
        },

        saveOwnCar() {
            this.showModal = false;
        },
        onProfilePictureChange(event) {
            const file = event.target.files[0];
            if (!file) return;

            if (!["image/jpeg", "image/png"].includes(file.type)) {
            this.profileError = "Only JPG/PNG allowed.";
            return;
            }
            if (file.size > 5 * 1024 * 1024) {
            this.profileError = "Max size is 5MB.";
            return;
            }

            this.newImage = file;
            this.newImagePreview = URL.createObjectURL(file);
            this.profileError = "";
        },
        onImageDrop(e) {
            const file = e.dataTransfer.files[0];
            this.onProfilePictureChange({ target: { files: [file] } });
        },

        onProfilePictureChangeDocument(event) {
            const file = event.target.files[0];
            if (!file) return;

            if (!["application/pdf", "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "image/jpeg", "image/png"].includes(file.type)) {
            this.documentError = "Only PDF/DOC/DOCX/JPG/PNG allowed.";
            return;
            }
            if (file.size > 10 * 1024 * 1024) {
            this.documentError = "Max size is 10MB.";
            return;
            }

            this.newDocument = file;
            this.newDocumentName = file.name;
            this.documentError = "";
        },

        triggerDocInput(id) {
            const ref = this.$refs['docInput' + id];
            if (Array.isArray(ref)) {
                ref[0].click();
            } else if (ref) {
                ref.click();
            }
        },

        onDocumentDrop(e, doc) {
            e.preventDefault();
            e.stopPropagation();
            const file = e.dataTransfer.files[0];
            if (!file) return;

            this.onProfileDocumentChange(
                { target: { files: [file] } },
                doc
            );
        },

        isImage(path) {
            return /\.(jpg|jpeg|png|gif)$/i.test(path);
        },

        onProfileDocumentChange(event, doc) {
            const file = event.target.files[0];
            if (!file) return;

            const allowed = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "image/jpeg",
                "image/png"
            ];

            if (!allowed.includes(file.type)) {
                this.documentError = 'Only PDF, DOC, DOCX, JPG, or PNG files are allowed.';
                return;
            }

            if (file.size > 10 * 1024 * 1024) {
                this.documentError = 'Maximum file size is 10MB.';
                return;
            }

            this.$set(doc, 'newFile', file);
            this.$set(doc, 'newDocumentName', file.name);
            this.$forceUpdate();

            this.documentError = '';
        },
        updateDocument(doc) {
            this.isLoading = true;

            const formData = new FormData();
            formData.append('documents_type', doc.documents_type);
            formData.append('expiration_date', doc.expiration_date);

            if (doc.newFile) {
                formData.append('documents', doc.newFile);
            }

            axios
                .post(`updateProfileDocument/${doc.id}`, formData)
                .then((response) => {
                    this.$bvToast.toast('Document updated successfully', {
                        title: 'Success',
                        variant: 'primary',
                        solid: true,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000
                    });
            // Update local document data with returned data from backend
                        const updatedDoc = response.data.data; // assume backend returns updated document
                        const index = this.editedUser.profile_document.findIndex(d => d.id === doc.id);
                        if (index !== -1) {
                            this.$set(this.editedUser.profile_document, index, {
                                ...updatedDoc,
                                newFile: null,
                                newDocumentName: null
                            });
                        }

                        this.documentError = '';
                    doc.newFile = null;
                    doc.newDocumentName = null;
                })
                .catch((error) => {
                    this.errors = error.response?.data?.errors || {};
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        deleteDocument(id, index) {
            this.documentToDelete = { id, index };
            this.showDeleteModal = true;
        },
        confirmDeleteDocument() {
            const { id, index } = this.documentToDelete;
            axios.delete(`deleteProfileDocument/${id}`)
                .then(() => {
                    this.editedUser.profile_document.splice(index, 1);
                    this.$bvToast.toast('Document deleted successfully', {
                        variant: 'danger',
                        solid: true
                    });
                })
                .catch((error) => {
                    console.error('Error deleting document:', error);
                })
                .finally(() => {
                    this.showDeleteModal = false;
                    this.documentToDelete = null;
                });
        },
        cancelDeleteDocument() {
            this.showDeleteModal = false;
            this.documentToDelete = null;
        },
        onNewDocumentDrop(e) {
            const file = e.dataTransfer.files[0];
            if (!file) return;

            this.validateAndSetNewDocument(file);
        },
        onNewDocumentChange(e) {
            const file = e.target.files[0];
            if (!file) return;

            this.validateAndSetNewDocument(file);
        },
        onNewDocumentChange(e) {
            const file = e.target.files[0];
            if (!file) return;

            this.validateAndSetNewDocument(file);
        },
        validateAndSetNewDocument(file) {
            const allowed = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "image/jpeg",
                "image/png"
            ];

            if (!allowed.includes(file.type)) {
                this.documentError = "Only PDF, DOC, DOCX, JPG or PNG allowed.";
                return;
            }

            if (file.size > 10 * 1024 * 1024) {
                this.documentError = "Max size is 10MB.";
                return;
            }

            this.newDocument.file = file;
            this.newDocument.name = file.name;
            this.documentError = '';
        },

        addNewDocument() {
            if (!this.newDocument.file ||
                !this.newDocument.documents_type ||
                !this.newDocument.expiration_date) {
                this.documentError = "All fields are required.";
                return;
            }

            const formData = new FormData();
            formData.append('user_id', this.editedUser.id);
            formData.append('documents', this.newDocument.file);
            formData.append('documents_type', this.newDocument.documents_type);
            formData.append('expiration_date', this.newDocument.expiration_date);

            axios.post('addProfileDocument', formData)
                .then(() => {

                    this.fetchUserDocuments();

                    this.newDocument = {
                        file: null,
                        name: null,
                        documents_type: '',
                        expiration_date: ''
                    };

                    this.$bvToast.toast('Document uploaded successfully', {
                        variant: 'success',
                        solid: true
                    });
                });
        },
        fetchUserDocuments() {
            axios.get(`UserGet/${this.editedUser.id}`)
                .then((response) => {
                    this.editedUser.profile_document = response.data.data.profile_document.map(doc => ({
                        ...doc,
                        newFile: null,
                        newDocumentName: null
                    }));
                });
        },
    },
};
</script>